const constants = {
  authenticationErrors: {
    NONE: '',
    TOKEN_EXPIRED: 'tokenExpired',
    TOKEN_EXPIRED_WHILE_LOGGED_IN: 'tokenExpiredWhileLoggedIn',
    LOGIN_FAILED: 'loginFailed',
  },
  requestTypes: {
    DOC: 'Doc',
    API: 'Api',
  },
};

module.exports = constants;
